import React from 'react';
import './styles/LogoBar.css';

const LogoBar: React.FC = () => (
	<div className='logo-header'>
		<div>
			OGO SA
		</div>
		<p className='logo-header-subtitle'>wan secure access</p>
	</div>
);

export default LogoBar;